import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { initGA, trackPageView } from '../lib/analytics/tracking';

export function AnalyticsProvider({ children }: { children: React.ReactNode }) {
  const location = useLocation();

  // Initialize GA once on mount
  useEffect(() => {
    initGA();
  }, []);

  // Track page views
  useEffect(() => {
    trackPageView(location.pathname + location.search);
  }, [location]);
  
  return <>{children}</>;
}